var scripts = document.getElementsByTagName('script');
var regex = new RegExp('ScriptLoadName-DoNotChange', 'i');
var found = false;

if (scripts && scripts.length) {
  for (var i = 0; i < scripts.length; i++) {
    if (!scripts[i]) continue;
    var path = scripts[i].getAttribute('src');
    if (path && path.match(regex)) {
      __webpack_public_path__ = path.substring(0, path.lastIndexOf('/') + 1);
      found = true;
      break;
    }
  }
}

if (!found) {
  for (var global in window.__setWebpackPublicPathLoaderSrcRegistry__) {
    if (global && global.match(regex)) {
      __webpack_public_path__ = global.substring(0, global.lastIndexOf('/') + 1);
      break;
    }
  }
}


//////////////////
// WEBPACK FOOTER
// D:/agent/4/_work/121/s/common/~/@microsoft/loader-set-webpack-public-path/lib
// module id = 118
// module chunks = 0


// WEBPACK FOOTER //
// webpack:///D:/agent/4/_work/121/s/common/~/@microsoft/loader-set-webpack-public-path/lib